import { z } from "zod";

import { type Theme, Theme as ThemeSchema } from "./theme.ts";

export const StoredThemeTokens = ThemeSchema.omit({ id: true, name: true });
export type StoredThemeTokens = z.infer<typeof StoredThemeTokens>;

export const hydrateTheme = (params: {
  id: string;
  name: string;
  tokens: unknown;
}): Theme | undefined => {
  const parsed = StoredThemeTokens.safeParse(params.tokens);
  if (!parsed.success) return undefined;
  return { ...parsed.data, id: params.id, name: params.name };
};
